module.exports = __webpack_public_path__ + "img/wom.dced5aa9.png";